export const menus = [
    {
        id: 1,
        type: "group",
        title: "companyIntroduction",
        icon: "faBuilding",
        children: [
            { id: 6, type: "item", title: "companyIntroduction", url: "/about/introduction" },
            { id: 7, type: "item", title: "companyHistory", url: "/about/history" },
            { id: 18, type: "item", title: "majorTask", url: "/about/majorTask" },
            { id: 8, type: "item", title: "onYourWayHere", url: "/about/location" },
            { id: 9, type: "item", title: "recruitmentInformation", url: "/about/recruit" }
            

        ]
    },
    {
        id: 2,
        type: "group",
        title: "product",
        icon: "faGears",
        children: [
            { id: 17, type: "item", title: "productDescriptions", url: "/liquid" },
            
        ]
    },
    {
        id: 3,
        type: "group",
        title: "majorBusiness",
        icon: "faGears",
        children: [
            { id: 10, type: "item", title: "syntheticNicotine", url: "/business/nicotine" },
            { id: 11, type: "item", title: "OEM", url: "/business/oem" },
            { id: 12, type: "item", title: "ODM", url: "/business/odm" },
            { id: 13, type: "item", title: "salesOfOnesOwnProducts", url: "/business/product" }
        ]
    },
    {
        id: 4,
        type: "group",
        title: "community",
        icon: "faUserTie",
        children: [
            { id: 14, type: "item", title: "community", url: "/community/community" },
        ]
    },
    {
        id: 5,
        type: "group",
        title: "customerSupport",
        icon: "faHeadset",
        children: [
            { id: 15, type: "item", title: "businessInquiry", url: "/support/contactUs" },
            { id: 16, type: "item", title: "customerService", url: "tel:07041875511" }
        ]
    }
];

